import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { DialogComponent } from "@commonComponents/dialog/dialog.component";
import { NgbActiveModal } from '@commonNodeModules/@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-analytics-modal',
    templateUrl: './analytics-modal.component.html',
    styleUrls: ['./analytics-modal.component.scss'],
    imports: [NgTemplateOutlet, DialogComponent]
})
export class AnalyticsModalComponent implements OnInit {

	// Achtung, wird über den modalService instanziert und nciht direkt im Template der jeweiligen Komponente referenziert.
	// Bitte nicht löschen, weil die Komponente in keinem Tempalte vorkommt.
	@Input() public title?: string
	@Input() public body?: string
	@Input() public footer?: string
	@Input() public hasDismissButton = false
	@Input() public inputHeaderTemplate?: TemplateRef<any>;
	@Input() public inputBodyTemplate?: TemplateRef<any>;
	@Input() public inputFooterTemplate?: TemplateRef<any>;

	headerTemplate: TemplateRef<any>;
	bodyTemplate: TemplateRef<any>;
	footerTemplate: TemplateRef<any>;

	constructor(
		public activeModal: NgbActiveModal,
	) { }


	ngOnInit(): void {
		this.headerTemplate = this.inputHeaderTemplate
		this.bodyTemplate = this.inputBodyTemplate
		this.footerTemplate = this.inputFooterTemplate
	}
}
